









































import Vue from "vue";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    heading: {}
  },
  inject: ["actionHandler", "selectedSamplesGetter"],
  methods: {
    checkboxChanged(changeEvent: { target: { checked: boolean } }) {
      if (!changeEvent.target.checked) {
        this.revertHeaderCss();
      }
      this.actionHandler("header_checkbox", changeEvent.target.checked);
    },
    deleteAll() {
      this.actionHandler("delete_selected");
    },
    //change tableheader css so as to fit the content as needed
    changeHeaderCss() {
      (this.$refs.headerContainer as any).parentElement.style.display = "flex";
      (this.$refs.headerContainer as any).parentElement.style.flexDirection =
        "row";
      (this.$refs.headerContainer as any).parentElement.style.justifyContent =
        "space-between";
      (this.$refs.headerContainer as any).parentElement.style.borderBottom =
        "solid 1px gainsboro";
      (this.$refs.headerContainer as any).parentElement.style.height = "40px";
    },
    //revert back the changes made to the table header
    revertHeaderCss() {
      (this.$refs.headerContainer as any).parentElement.style.display = "grid";
      (this.$refs.headerContainer as any).parentElement.style.flexDirection =
        "";
      (this.$refs.headerContainer as any).parentElement.style.justifyContent =
        "";
      (this.$refs.headerContainer as any).parentElement.style.borderBottom =
        "solid 1px gainsboro";
    }
  },
  computed: {
    checked() {
      if ((this as any).selectedSamplesGetter().length > 0) {
        this.changeHeaderCss();
        return true;
      } else {
        return false;
      }
    },
    selectedSamples() {
      return (this as any).selectedSamplesGetter();
    }
  },
  mounted() {
    (this.$refs.headerContainer as any).parentElement.style.borderBottom =
      "solid 1px gainsboro";
  }
});
